<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Categoría</th>
                <th :class="StyleTh">Estatus</th>

                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index" >
					<td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
					<td><h6 :class="StylePr">{{lista.Categoria}}</h6></td>
                    <td><p :class="StyleTd">{{(lista.EstatusAct==1)?'Activo':'InActivo'}}</p></td>
                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdCategoriaGaleria" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                                 <!-- Remover v-show en caso de agregar más botones -->
                                 <CMoreButtonsL v-show="segurity.ViewSection">
							        <template slot="bodyBtnsL">
                                        <template v-if="segurity.ViewSection">
                                            <li @click="IraGaleria(lista)">
                                                <a class="dropdown-item">
                                                    <i class="fa fa-photo"></i> Galeria
                                                </a>
                                            </li>
                                        </template>
                                    </template>
                                </CMoreButtonsL>
                            </template>
						</CBtnAccion>     
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="4"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>
	</div>
</template>

<script>

import Form from '@/views/catalogos/categoriaGaleria/Form.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionCategoriaGaleria';

export default {
    name: 'ListaCategoriaGaleria',
    components: {
        Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Categorías Galería',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Configuración'
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 10,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            ConfigModal:{
                ModalTitle: "Formulario Categoría Galería",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,                
            ListaHeader: [],
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("categoriasGaleria",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('categoriasGaleria/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        IraGaleria(item){
            this.$router.push({name:'galeriaImagen',params:{pObjEnviado: item}});
        }
    },
    created()
    {
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });
        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
